import { render, staticRenderFns } from "./ClassDefinition.vue?vue&type=template&id=33c2719a&scoped=true&"
import script from "./ClassDefinition.vue?vue&type=script&lang=js&"
export * from "./ClassDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2719a",
  null
  
)

export default component.exports